import { TemplateNodeSchema } from '@ulysses-inc/harami_api_client'
import { Select, Typography } from 'antd'
import { FC, ReactNode, useId } from 'react'
import styled from 'styled-components'

const FormRow = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`

const FormLabel = styled.div`
  margin-bottom: 10px;
  width: 100%;
`

const Description = styled.p`
  font-size: 12px;
  color: gray;
  margin-top: 4px;
`

const { Text } = Typography

const QuestionSelect = styled(Select)`
  width: 100%;
`

type Props = {
  selectedQuestionId?: string
  onChange: (uuid: string | undefined) => void
  disabled?: boolean
  nodes: TemplateNodeSchema[]
  label: string
  placeholder: string
  description?: ReactNode
}

export const QuestionAutocomplete: FC<Props> = ({
  selectedQuestionId,
  onChange,
  disabled = false,
  nodes,
  label,
  placeholder,
  description,
}) => {
  const options = nodes.map(q => ({
    label: q.question?.name || '名前のない質問',
    value: q.uuid,
  }))

  const descriptionId = useId()

  // 選択された値がoptionsに存在するかチェック
  const isValidSelection =
    selectedQuestionId &&
    options.some(option => option.value === selectedQuestionId)

  // 無効な選択の場合は特別なオプションを追加
  const displayOptions = isValidSelection
    ? options
    : [
        ...options,
        ...(selectedQuestionId
          ? [
              {
                label: `無効な選択`,
                value: selectedQuestionId,
                disabled: true,
              },
            ]
          : []),
      ]

  return (
    <FormRow>
      <FormLabel>
        <Text strong>{label}</Text>
      </FormLabel>
      <div>
        <QuestionSelect
          showSearch
          optionFilterProp="label"
          placeholder={placeholder}
          value={selectedQuestionId}
          onChange={value => {
            onChange(typeof value === 'string' ? value : undefined)
          }}
          disabled={disabled}
          allowClear
          options={displayOptions}
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          aria-describedby={description ? descriptionId : undefined}
        />
        {description && (
          <Description id={descriptionId}>{description}</Description>
        )}
      </div>
    </FormRow>
  )
}
